export const enum NavArea {
    BUY,
    RENT,
    MY_AREA,
}
